import React from 'react';
import Modal from '../Modal';

const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';
import Button from '../Button';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    text-align: center;
  }
`;

const ButtonsWrapper = styled.div`
  width: 100%;
  margin-top: 56px;
`;

// import { Container } from './styles';
type ModalConfirmDocumentProps = {
  visible: boolean;
  documentType: string;
  onConfirmIdentity: () => void;
};
export const ModalConfirmDocument: React.FC<ModalConfirmDocumentProps> = ({
  visible,
  documentType,
  onConfirmIdentity
}) => {
  return (
    <Modal visible={visible} onClose={onConfirmIdentity} withoutCloseButton>
      <Container>
        <img src={warningIcon} alt="warning" />
        <h3 className="title">{`${documentType} já cadastrado`}</h3>
        <p className="subtitle">{`Para acessar a conta vinculada a esse ${documentType}, confirme sua identidade.`}</p>
        <ButtonsWrapper>
          <Button disabled={!visible} type="button" title="Confirmar identidade" />
          <Button
            disabled={!visible}
            type="button"
            title="Continuar agendamento"
            tertiary
            onClick={onConfirmIdentity}
          />
        </ButtonsWrapper>
      </Container>
    </Modal>
  );
};
